export default {
  title: "Let's stay in touch!",
  bottom: "Made with React.js & Gatsby.js with ❤️ and ☕ by Alexandre Le Lain.",
  mail: "lelain.alexandre@gmail.com",
  twitter: "@a_lelain",
  github: "alexandre-lelain",
  linkedin: "alexandre-lelain",
}
